<script setup lang="ts">
  import { useLocale } from '@tundr/i18n';
  import { DatetimeFormatType } from '@tundr/i18n';
  import { isToday } from 'date-fns';
  import { Tooltip, TooltipSize } from '@tundr/ds-components';

  const { d } = useLocale('table');

  withDefaults(
    defineProps<{
      date: string | Date;
      format?: DatetimeFormatType;
    }>(),
    {
      format: DatetimeFormatType.DATETIME,
    },
  );
</script>

<template>
  <div>
    <Tooltip
      v-if="format === DatetimeFormatType.SHORT_DATE && isToday(date)"
      :size="TooltipSize.Sm"
      :title="d(date, format, true)"
    >
      <span> {{ d(date, format) }} </span>
    </Tooltip>
    <span v-else> {{ d(date, format) }} </span>
  </div>
</template>
